import i18next from 'i18next'
import z from 'zod'

import { MAX_SAFE_GQL_INTEGER } from 'providers/graphql/constants'
import { zNumericIntegerString } from 'providers/zod/types'
import { isValidCountryCode } from 'utils/country'
import { isValidCurrencyCode } from 'utils/currency'
import { GamOrderRetargetingDealsDeliverySlice } from './useGetGamOrderRetargetingDealsDelivery'

export const schema = z.object({
  currency: z
    .string()
    .refine((value: string | undefined): boolean => {
      if (value === undefined || value.length === 0) {
        return true
      } else {
        return isValidCurrencyCode(value)
      }
    }, i18next.t('features/globalSetup:googleAdManagerConnection.setupRetargetingDeliveryItems.form.currency.error'))
    .optional(),
  geo: z
    .string()
    .length(2)
    .refine((value: string | undefined): boolean => {
      if (value !== undefined && value.length > 0) {
        return isValidCountryCode(value)
      } else return false
    }, i18next.t('features/globalSetup:googleAdManagerConnection.setupRetargetingDeliveryItems.form.geo.error')),
  proposalId: zNumericIntegerString.min(1).max(MAX_SAFE_GQL_INTEGER),
})

export type Schema = z.infer<typeof schema>

export const schemaDefault = (
  gamOrderRetargetingDealsDelivery?: GamOrderRetargetingDealsDeliverySlice,
): Schema => {
  if (gamOrderRetargetingDealsDelivery === undefined) {
    return {
      currency: undefined,
      geo: '',
      proposalId: '',
    }
  }

  const { currency, geo, proposalId } = gamOrderRetargetingDealsDelivery

  return {
    currency,
    geo,
    proposalId,
  }
}
